import React from 'react';
import useLoadingStore from '../../store/loadingStore';

const LoadingOverlay = () => {
    const { isLoading } = useLoadingStore();

    if (!isLoading) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-20 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg">
                <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-200 border-t-amber-500"></div>
                    <span className="ml-4 text-gray-700 font-medium">로딩 중</span>
                </div>
            </div>
        </div>
    );
};

export default LoadingOverlay; 